var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EntryForm',{attrs:{"form":_vm.form,"categories":_vm.categories,"tags":_vm.tags,"loaderPdf":true,"title":"Crear nuevo libro","buttonText":"Publicar"},on:{"form":function($event){_vm.form=$event.target.value},"submit":_vm.doPublish}})}
var staticRenderFns = []

export { render, staticRenderFns }